import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface InputKpiResponse {
  current_price: number;
  competition_price: number;
  current_distribution: number;
  competition_distribution: number;
  distribution: string[];
}

export interface InputAdditionKpiResponse {
  ko_segment_ppl: number;
  ko_segment_distribution: number;
  comp_segment_ppl: number;
  comp_segment_distribution: number;
  distribution: string[];
}

export const fetchKpiCalculationData = async (payload: any) => {
  return fetchData<InputKpiResponse>(API_ENDPOINTS.SCENARIO_INPUT.FETCH_INPUT_KPI_CALCULATIONS_DATA, payload);
};

export const fetchLaunchKpiCalculationData = async (payload: any) => {
  return fetchData<InputAdditionKpiResponse>(API_ENDPOINTS.SCENARIO_INPUT.FETCH_LAUNCH_KPI_CALCULATIONS_DATA, payload);
};
